<mat-expansion-panel [disabled]="true" [expanded]="filterBoxExpanded()" class="mat-elevation-z0 mb-3" hideToggle="true">
  <mat-expansion-panel-header class="pl-0">
    <div class="flex flex-1 justify-space-between">
      <div class="flex-1 flex items-center flex-row">
        <span class="mr-3"> Incident Risk </span>

        <app-pan-button-group [(panRadioGroup)]="theftRisk" (panRadioGroupChange)="handleRiskChange()">
          <app-pan-button [panRadio]="'low'" color="info">Low</app-pan-button>
          <app-pan-button [panRadio]="'medium'" color="info">Medium </app-pan-button>
          <app-pan-button [panRadio]="'high'" color="info">High </app-pan-button>
          <app-pan-button [panRadio]="'all'" color="info">All </app-pan-button>
        </app-pan-button-group>
      </div>

      <div>
        <app-pan-button (click)="togglePanel()" color="info" icon="filter_list">
          {{ filterBoxExpanded() ? " Hide filters" : " Filter results" }}
        </app-pan-button>
      </div>
    </div>
  </mat-expansion-panel-header>

  <div class="mb-5">
    <app-page-filters
      [allowLocationSelection]="true"
      [locationSelectionMulti]="true"
      locationSelectionLabel="Locations"
      (selectedLocationsChange)="handleFiltersChanged()"
      [(selectedLocations)]="selectedLocations"
      [allowDateRangeSelection]="true"
      [dateRangeShowClear]="true"
      [(dateRangeStart)]="dateFrom"
      dateRangeStartLabel="Cancel Date From"
      (dateRangeStartChange)="handleFiltersChanged()"
      [(dateRangeEnd)]="dateTo"
      dateRangeEndLabel="Cancel Date To"
      (dateRangeEndChange)="handleFiltersChanged()"
      [dateRangeMaximumDays]="dateRangeMaximumDays"
    >
    </app-page-filters>
  </div>

  <div class="flex">
    <app-pan-button (click)="resetFilters()" [disabled]="loadingData()" class="mb-1">Clear all filters</app-pan-button>

    <app-pan-button
      (click)="getIdentities()"
      [state]="loadingData() ? 'loading' : 'default'"
      [disabled]="loadingData() || !highlightApply()"
      [color]="highlightApply() ? 'primary' : 'default'"
      class="mb-1 ml-2"
    >
      Apply
    </app-pan-button>
  </div>
</mat-expansion-panel>

<mat-card-content>
  <div>
    @let visible = visibleIdentities();

    @if (loadingData()) {
      <div class="flex justify-center mt-3 p-2">
        <app-pan-spinner size="xl"></app-pan-spinner>
      </div>
    } @else if (visible?.length === 0) {
      <div class="flex justify-center mt-3 p-2">
        <p>No results</p>
      </div>
    }

    <div [class]="visible?.length !== 0 ? 'block' : 'hidden'">
      <div class="example-container mat-elevation-z0">
        <mat-table
          [class.hidden]="loadingData()"
          #table
          [dataSource]="visible"
          matSort
          matSortActive="num_activities"
          matSortDirection="desc"
        >
          <ng-container matColumnDef="num_activities">
            <mat-header-cell *matHeaderCellDef mat-sort-header># of activities</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <app-pan-button
                class="w-full"
                expand="block"
                size="sm"
                color="info"
                (click)="getRecord(element)"
                [disabled]="!element.location_id"
              >
                {{ getShowActivitiesButtonText(element) }}
              </app-pan-button>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="img_id">
            <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="true">Image</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <app-pan-button
                size="sm"
                color="info"
                [state]="element.showingImage ? 'loading' : 'default'"
                [disabled]="element.showingImage"
                (click)="$event.stopPropagation(); selectedImageUrl.set(element.image_id); imageModal.show()"
                >Show</app-pan-button
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="location_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
            <mat-cell *matCellDef="let element" aria-label="">
              {{ element.location_name }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="branch">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Branch</mat-header-cell>
            <mat-cell *matCellDef="let element" aria-label="">
              {{ element.branch }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Total</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ getTotalColumnText(element) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="cancel_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Latest cancel date</mat-header-cell>
            <mat-cell *matCellDef="let element" class="w-[200px]">
              {{ element.cancel_date | date: "MM/dd/yyyy hh:mm:ss a" }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            [cdkDetailRowTpl]="tpl"
            [cdkDetailRow]="row"
            (detailRowClick)="getRecord(row)"
          >
          </mat-row>
        </mat-table>

        <mat-paginator [class.!hidden]="loadingData()" [length]="numberOfResults()" [pageSize]="itemsPerPage()"></mat-paginator>
      </div>
    </div>
  </div>

  <ng-template #tpl let-element>
    @let tpi = transactionsPerIdentity[element.face_id];

    @if (tpi?.loadingData) {
      <div class="flex justify-center p-2">
        <app-pan-spinner size="xl"></app-pan-spinner>
      </div>
    }

    @if (!tpi?.loadingData && !tpi?.haveData) {
      <div class="flex justify-center p-2 italic">There is no data for the specified time range.</div>
    }

    @if (tpi?.haveData) {
      <div class="mat-row detail-row bg-slate-300 overflow-hidden">
        <div [style.display]="tpi.data.length !== 0 ? 'block' : 'none'" class="mat-elevation-z0 p-2">
          <table [dataSource]="tpi.data" class="mat-elevation-z0 bg-slate-300" mat-table>
            <ng-container matColumnDef="img_id">
              <th *matHeaderCellDef mat-header-cell class="w-[100px]">Details</th>
              <td *matCellDef="let row" mat-cell>
                @if (row.image_id) {
                  <app-pan-button color="info" size="sm" (click)="loadTransactionPopup(row)"> Show </app-pan-button>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="location_name">
              <th *matHeaderCellDef mat-header-cell>Location</th>
              <td *matCellDef="let row" mat-cell>{{ row.location_name }}</td>
            </ng-container>

            <ng-container matColumnDef="branch">
              <th *matHeaderCellDef mat-header-cell>Branch</th>
              <td *matCellDef="let row" mat-cell>{{ row.branch }}</td>
            </ng-container>

            <ng-container matColumnDef="user_name">
              <th *matHeaderCellDef mat-header-cell>User</th>
              <td *matCellDef="let row" mat-cell>{{ row.user_name }}</td>
            </ng-container>

            <ng-container matColumnDef="theft_category">
              <th *matHeaderCellDef mat-header-cell>Incident Risk</th>
              <td *matCellDef="let row" mat-cell>
                @switch (row.theft_category) {
                  @case ("Low") {
                    <app-pan-chip [width]="100" color="success" size="sm">Low</app-pan-chip>
                  }

                  @case ("Medium") {
                    <app-pan-chip [width]="100" color="warning" size="sm">Medium</app-pan-chip>
                  }

                  @case ("High") {
                    <app-pan-chip [width]="100" color="danger" size="sm">High</app-pan-chip>
                  }

                  @default {
                    <app-pan-chip [width]="100" color="default" size="sm">{{ row.theft_category | titlecase }}</app-pan-chip>
                  }
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th *matHeaderCellDef mat-header-cell>Total</th>
              <td *matCellDef="let row" mat-cell class="w-[80px]">{{ row.total | currency }}</td>
            </ng-container>

            <ng-container matColumnDef="num_items">
              <th *matHeaderCellDef mat-header-cell>Num items</th>
              <td *matCellDef="let row" mat-cell>{{ row.num_items }}</td>
            </ng-container>

            <ng-container matColumnDef="cancel_date">
              <th *matHeaderCellDef mat-cell mat-header-cell>Cancel date</th>
              <td *matCellDef="let row" mat-cell class="w-[200px]">
                {{ row.cancel_date | date: "MM/dd/yyyy hh:mm:ss a" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="theft">
              <th *matHeaderCellDef mat-header-cell>Incident Status</th>
              <td *matCellDef="let row" mat-cell class="w-[150px]">
                <mat-menu #appMenu="matMenu" xPosition="before">
                  @if (row.theftLabel === "No incident" || row.is_theft === null) {
                    <button (click)="handleTheftChange(true, row)" mat-menu-item>Incident</button>
                  }
                  @if (row.theftLabel === "Incident" || row.is_theft === null) {
                    <button (click)="handleTheftChange(false, row)" mat-menu-item>No incident</button>
                  }
                </mat-menu>

                <app-pan-button
                  expand="block"
                  [color]="row.theftLabel === 'No incident' ? 'success' : row.theftLabel === 'Incident' ? 'danger' : 'warning'"
                  size="sm"
                  [state]="row.updatingCategory ? 'loading' : 'default'"
                  [matMenuTriggerFor]="appMenu"
                >
                  {{ row.theftLabel }}
                </app-pan-button>
              </td>
            </ng-container>

            <ng-container matColumnDef="badges">
              <th *matHeaderCellDef mat-header-cell>Interaction history</th>
              <td *matCellDef="let row" mat-cell>
                @if (row.last_seen) {
                  <mat-icon aria-hidden="true">visibility</mat-icon>
                }
                @if (!row.last_seen) {
                  <mat-icon aria-hidden="true">visibility_off</mat-icon>
                }
                @if (row.num_videos > 0) {
                  <mat-icon aria-hidden="true">ondemand_video</mat-icon>
                }
                @if (row.num_comments > 0) {
                  <mat-icon aria-hidden="true">comment</mat-icon>
                }
              </td>
            </ng-container>

            <tr *matHeaderRowDef="detailColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: detailColumns" mat-row></tr>
          </table>
        </div>
      </div>
    }
  </ng-template>
</mat-card-content>

<app-pan-modal #imageModal (modalClose)="selectedImageUrl.set('')">
  <div header>Suspect Image</div>

  <div body class="flex flex-col gap-2">
    @let url = selectedImageUrl();

    @if (url) {
      <app-suspect-image [cancellationId]="url"></app-suspect-image>
    }
  </div>

  <div footer>
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>

<app-pan-modal
  class="hide-close-button"
  #transactionDetailsModal
  size="fs"
  [shouldBodyScroll]="true"
  [topLevel]="false"
  [maxBodyHeight]="'80vh'"
  (modalClose)="showTransaction.set(undefined); transactionDetails.set(undefined)"
>
  <div header>Transaction Details</div>

  <div body>
    @let txn = showTransaction();
    @let details = transactionDetails();

    @if (loadingTransactionDetails()) {
      <div class="flex justify-center mt-3 p-2">
        <app-pan-spinner size="xl"></app-pan-spinner>
      </div>
    }

    @if (txn && details) {
      <app-transaction-details
        mode="normal"
        [cancellationId]="txn.image_id"
        [isTheft]="txn.is_theft"
        [lastSeen]="txn.last_seen"
        [hasComments]="txn.num_comments > 0"
        [hasVideo]="txn.num_videos > 0"
        [transactionDetails]="details"
        (theftCategoryChange)="handleTheftCategoryChange($event)"
      ></app-transaction-details>
    }
  </div>

  <div footer>
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
